import React from 'react';
import styled from 'styled-components/macro';
import { Gender as GenderType } from '../utils/data_types';
import { THEME_COLORS } from '../utils/theme';
import { SectionBannerPink, SectionHeader } from './styles';
import BarChart from './graphs/BarChart';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Graph = styled.div`
  width: 70vw;
  min-width: 0;
  min-height: 0;
  margin: 15px;
  padding: 15px;
`;

interface Props {
  genderData: GenderType;
}

export const Gender: React.FC<Props> = props => {
  let data = props.genderData;
  return (
    <SectionBannerPink>
      <SectionHeader color={THEME_COLORS.headerWhite}>Gender</SectionHeader>
      <Container>
        <Graph>
          <BarChart
            colNames={['Male', 'Female', 'Non-Binary', 'Did Not Identify']}
            data={[data.genderMale, data.genderFemale, data.genderNonBinary, data.genderDidNotIdentify || 0]}
            show_legend={true}
          />
        </Graph>
      </Container>
    </SectionBannerPink>
  );
};
